import * as React from 'react';
import { useTranslation } from 'Shared/Hooks/useTranslation';
import MultiClamp from 'react-multi-clamp';

import CourseDetailPrice from 'Jsx/CourseDetail/components/CourseDetailPrice';
import useCanEnrollWithFirstEnroll from 'Jsx/CourseDetail/hooks/useCanEnrollWithFirstEnroll';

import locales from '../../i18n/localeEs';
import useCoursePromoCountdown from '../../hooks/useCoursePromoCountdown';

const translations = locales.es;

const CourseMode = ({
  isBuyable,
  renderTransactionButtons,
  SecondaryButtons,
  course,
  canRenderCountdown,
}) => {
  const [isSticky, setIsSticky] = React.useState(false);
  const { canEnrollToCourseFreemium } = useCanEnrollWithFirstEnroll();
  const { t } = useTranslation();
  const { promoRemainingTime } = useCoursePromoCountdown(course.dueDate);

  React.useEffect(() => {
    const stickyElm = document.getElementById('sticky-card');

    const observer = new IntersectionObserver(
      ([e]) => setIsSticky(e.intersectionRatio < 1),
      { threshold: [0, 1] },
    );

    if (stickyElm && course.courseType === 'free') {
      observer.observe(stickyElm);
    }
    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className="p-24">
      <h4 className={isSticky ? 'block font-h4' : 'hidden font-h4'}>
        <MultiClamp>{course.title}</MultiClamp>
      </h4>
      <div>
        {isBuyable && !canEnrollToCourseFreemium && (
          <div className="mb-8">
            {canRenderCountdown && promoRemainingTime && (
              <p className="mt-4 font-link text-red-main">
                {t('OFFER_END_IN', {
                  defaultValue: translations.OFFER_END_IN,
                })}{' '}
                {promoRemainingTime}!
              </p>
            )}
            <div className="flex items-baseline mb-12 mt-24 sm:mt-0 sm:mb-0">
              <CourseDetailPrice />
            </div>
          </div>
        )}
        <div className="mt-24">{renderTransactionButtons()}</div>
      </div>
      {SecondaryButtons}
    </div>
  );
};

export default CourseMode;
